import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import classes from "./OhHeader.module.scss"

const OhHeader = props => {
  const { order } = props

  const [t] = useTranslation()

  const showPaidDate =
    !!order.paymentDate &&
    order.accountRole === "access" &&
    order.orderStatus === "paid"

  return (
    <Fragment>
      {
        order.dailyOrderNumber !== undefined &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("شماره_روزانه")}
          </span>
          <div className={classes["date"]}>
            {String(order.dailyOrderNumber).padStart(3, "0")}
          </div>
        </div>
      }

      {
        !!order.referenceCode &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("کد_پیگیری")}
          </span>
          <div className={classes["date"]}>
            {order.referenceCode}
          </div>
        </div>
      }

      {
        order.deliveryType === "dineIn" &&
        <div className={classes["title-container"]}>
          <div className={classes["row"]}>
            <span>{t("شماره_میز")}:</span>
            <b>{order.tableNumber}</b>
          </div>
        </div>
      }

      {
        order.deliveryType === "selfPickup" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("بیرون_بر")}
          </span>
        </div>
      }

      <div className={classes["title-container"]}>
        <span className={classes["title"]}>
          {t("تاریخ_ایجاد_سفارش")}
        </span>
        <div className={classes["date"]}>
          {moment(order.date).format("jYYYY/jMM/jDD - HH:mm")}
        </div>
      </div>

      {
        showPaidDate &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_پرداخت")}
          </span>
          <div className={classes["date"]}>
            {moment(order.paymentDate).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      <div className={classes["title-container"]}>
        <span className={classes["title"]}>
          {t("جزئیات_شعبه")}
        </span>
        <div className={classes["date"]}>
          {order.branchName}
        </div>
      </div>
    </Fragment>
  )
}

export default OhHeader
